import PropTypes from 'prop-types'
import { useContext } from 'react'

import { AccordionContext } from 'components/common/Accordion'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'

export default function SectionTitle({
  icon,
  title,
  info,
  className,
  iconClassName
}) {
  const { expanded } = useContext(AccordionContext)
  const ComponentIcon = typeof icon === 'function' ? icon : null
  const iconStyles = {
    display: 'grid',
    alignItems: 'center',
    height: theme.space[6],
    width: theme.space[6],
    fontSize: theme.fontSizes[5],
    justifySelf: 'center',
    gridRow: 'span 2',
    color: expanded ? theme.colors.steel[2] : theme.colors.steel[1]
  }

  return (
    <div
      className={className}
      css={{
        display: 'grid',
        fontSize: theme.fontSizes[5],
        gridTemplateColumns: '48px minmax(max-content, 1fr)',
        gridColumnGap: theme.space[2],
        alignItems: 'center'
      }}
    >
      <div css={iconStyles}>
        {ComponentIcon ? (
          <ComponentIcon />
        ) : (
          <Icon className={iconClassName} icon={icon} />
        )}
      </div>

      <Text
        as="h4"
        color="medium"
        css={{
          gridRow: info ? 'auto' : 'span 2'
        }}
      >
        {title}
      </Text>
      {info && <Text as="small">{info}</Text>}
    </div>
  )
}

SectionTitle.propTypes = {
  expanded: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  title: PropTypes.string.isRequired,
  info: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string
}

SectionTitle.defaultProps = {
  className: '',
  iconClassName: ''
}
